import * as React from "react";
const SvgRefreshCw05 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.559 11.899a1 1 0 0 1 .888 1.1 9.49 9.49 0 0 1-4.698 7.229c-4.129 2.383-9.303 1.315-12.182-2.309l-.108.406a1 1 0 1 1-1.932-.518l.733-2.731.031-.098a1 1 0 0 1 1.193-.61l2.732.732a1 1 0 0 1-.518 1.932l-.343-.092a7.501 7.501 0 0 0 13.104-4.153 1 1 0 0 1 1.1-.888M7.25 3.773c4.129-2.384 9.303-1.316 12.182 2.307l.109-.405a1 1 0 0 1 1.932.518l-.733 2.732a1 1 0 0 1-1.224.707L16.783 8.9a1 1 0 0 1 .518-1.932l.343.092A7.502 7.502 0 0 0 4.54 11.213a1 1 0 0 1-1.988-.212A9.49 9.49 0 0 1 7.25 3.773"
}));
export default SvgRefreshCw05;
//# sourceMappingURL=RefreshCw05.js.map